import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Toaster } from '../components/ui/sonner';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (!token) {
      setStatus('invalid');
      return;
    }

    axios
      .post(`${API}/auth/verify-email`, { token })
      .then(() => setStatus('success'))
      .catch((err) => {
        setStatus(err.response?.data?.detail?.includes('expirado') ? 'expired' : 'invalid');
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-8">
      <div className="noise-overlay" />
      <div className="w-full max-w-md relative z-10 text-center" data-testid="verify-email-page">
        <div className="flex items-center justify-center gap-3 mb-8">
          <img src="/logo-ar.png" alt="AR Performance" className="w-10 h-10 object-contain" />
          <span className="font-heading text-xl font-bold text-white">AR PERFORMANCE</span>
        </div>

        {status === 'loading' && (
          <div className="space-y-4">
            <Loader2 className="w-12 h-12 text-primary animate-spin mx-auto" />
            <p className="text-zinc-400">Verificando email...</p>
          </div>
        )}

        {status === 'success' && (
          <div className="space-y-4">
            <div className="w-16 h-16 bg-green-500/10 rounded-full flex items-center justify-center mx-auto">
              <CheckCircle className="w-8 h-8 text-green-500" />
            </div>
            <h1 className="font-heading text-2xl font-bold text-white">EMAIL VERIFICADO</h1>
            <p className="text-zinc-400">Tu cuenta ha sido verificada correctamente.</p>
            <Link to="/dashboard">
              <Button className="mt-4 bg-primary hover:bg-primary/90 text-white">
                Ir al Dashboard
              </Button>
            </Link>
          </div>
        )}

        {status === 'invalid' && (
          <div className="space-y-4">
            <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mx-auto">
              <XCircle className="w-8 h-8 text-red-500" />
            </div>
            <h1 className="font-heading text-2xl font-bold text-white">ENLACE INVÁLIDO</h1>
            <p className="text-zinc-400">Este enlace de verificación no es válido.</p>
            <Link to="/login">
              <Button variant="outline" className="mt-4 border-white/20 text-white hover:bg-white/10">
                Ir al Login
              </Button>
            </Link>
          </div>
        )}

        {status === 'expired' && (
          <div className="space-y-4">
            <div className="w-16 h-16 bg-yellow-500/10 rounded-full flex items-center justify-center mx-auto">
              <XCircle className="w-8 h-8 text-yellow-500" />
            </div>
            <h1 className="font-heading text-2xl font-bold text-white">ENLACE EXPIRADO</h1>
            <p className="text-zinc-400">Este enlace ha expirado. Inicia sesión para solicitar uno nuevo.</p>
            <Link to="/login">
              <Button className="mt-4 bg-primary hover:bg-primary/90 text-white">
                Ir al Login
              </Button>
            </Link>
          </div>
        )}
      </div>
      <Toaster position="top-right" richColors />
    </div>
  );
};

export default VerifyEmailPage;
